import { CloseCircleFilled, QuestionCircleOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { useRequest } from 'ahooks';
import { Button, Card, Input, Modal, Popover, Tag, message, Typography } from 'antd';
import { addSensitiveWord, getSensitiveWordList, removeSensitiveWord } from './api';
import { useState } from 'react';

const TOTAL_LIMIT = 200;
const maxLength = 50;

const SensitiveWord = () => {
  const { t } = useTranslate();
  const { data, refresh } = useRequest(async () => {
    try {
      const { word } = await getSensitiveWordList();
      return word;
    } catch (error) {
      message.error(t('phrase.获取数据失败，请稍后再试'));
    }
  });
  const [input, setInput] = useState('');
  const { runAsync: removeTag, loading: removing } = useRequest(
    async (word: string) => {
      try {
        await removeSensitiveWord(word);
        refresh();
        message.success(t('已删除'));
      } catch (error) {
        message.error(t('translation.操作失败，请稍后再试'));
      }
    },
    { manual: true },
  );
  const { runAsync: save, loading: saving } = useRequest(
    async () => {
      const text = input.trim();
      if (text.length > maxLength) {
        message.error(t('最多x个字符', { count: maxLength }));
        return;
      }
      if (data?.includes(text)) {
        message.error(t('存在同名称敏感词'));
        return;
      }
      try {
        await addSensitiveWord(input);
        refresh();
        setInput('');
        message.success(t('已添加'));
      } catch (error) {
        message.error(t('translation.操作失败，请稍后再试'));
      }
    },
    { manual: true },
  );
  const count = data?.length ?? 0;
  return (
    <div className="p-4">
      <Card
        title={
          <div className="overflow-hidden">
            <div className="flex items-center pr-5">
              <span>{t('managementCenter.navigation.store.restrictedWords')}</span>
              <span className="flex-1 overflow-hidden text-xs font-normal ml-2 text-[#515359]">
                <Typography.Text
                  ellipsis={{
                    tooltip: {
                      title: t('敏感词副标题'),
                    },
                  }}
                >
                  {t('敏感词副标题')}
                </Typography.Text>
              </span>
            </div>
          </div>
        }
        extra={
          <Popover
            placement="bottomRight"
            content={
              <div className="w-60 whitespace-break-spaces break-words">{t('敏感词使用说明')}</div>
            }
          >
            <Button className="!py-0 !h-7">
              {t('功能说明')} <QuestionCircleOutlined />
            </Button>
          </Popover>
        }
      >
        <div>
          <div className="relative">
            <div className="before:absolute before:left-0 before:top-1 before:content-[''] before:border-solid before:w-1 before:h-[14px] before:bg-primary before:border-0 pl-2">
              {t('敏感词词库')}({count}/{TOTAL_LIMIT})
            </div>
            <div className="flex flex-wrap gap-1 mt-3 mb-7">
              {data?.map((x) => (
                <Tag>
                  {x}
                  <CloseCircleFilled
                    className="ml-1 !text-[#84868C]"
                    onClick={() => {
                      Modal.confirm({
                        title: t('确认要删除吗'),
                        content: t('删除后不可恢复'),
                        onOk: () => removeTag(x),
                        okButtonProps: {
                          disabled: removing,
                        },
                      });
                    }}
                  />
                </Tag>
              ))}
            </div>
            <div className="relative">
              <div className="before:absolute before:left-0 before:top-1 before:content-[''] before:border-solid before:w-1 before:h-[14px] before:bg-primary before:border-0 pl-2">
                {t('添加敏感词')}
              </div>
              <div className="w-[640px] pt-2 relative">
                <Input.TextArea
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  className="pb-8"
                  autoSize={{ minRows: 4, maxRows: 10 }}
                  rows={10}
                  size="middle"
                />
                <Button
                  className="!absolute bottom-4 right-4"
                  type="primary"
                  disabled={!input.trim() || count >= TOTAL_LIMIT}
                  onClick={save}
                  loading={saving}
                >
                  {t('添加_敏感词')}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SensitiveWord;
